PJQ.views.timecards.BaseDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Results Available"
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        phoneWidth: '125px'
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeDataTableRender: function () {
        this.options.rowCallback = function (row, data) {
        };

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        this.options.onRowDoubleClick = _.bind(function (row) {
            if (row.data()) {
                this.editRow(row.data());
            }
        }, this);

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            if (this.options.settings.orderBy !== 'sortOrder') {
                if (_.size(this.options.settings.columns) === 0) {
                    this.options.settings.orderBy = this.options.settings.columnsDefault[0];
                } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                    this.options.settings.orderBy = this.options.settings.columns[0];
                }
            }
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy) {
                    this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
                }
            }, this));

        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    afterDataTableRender: function () {
        this.$el.on('order.dt', _.bind(function (e, settings, details) {
            if (this.$dataTable[0].id !== settings.oInstance[0].id)
                return;

            if (!this.options.settings)
                return;

            let oldOrder = 0, columns = this.getColumns(false);
            _.each(columns, _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy)
                    oldOrder = index;
            }, this));

            if (oldOrder !== details[details.length - 1].src || this.options.settings.orderAscending !== (details[details.length - 1].dir === 'asc')) {
                this.options.settings.orderBy = columns[details[details.length - 1].src].columnData;
                this.options.settings.orderAscending = details[details.length - 1].dir === 'asc';
                this.options.timecardsView.userSettings.save();
            }
        }, this));

        this.$el.on('draw.dt', _.bind(function () {
            this.afterDataTableRenderChild();
        }, this));

        if (typeof this.options.afterDataTableRender === 'function') {
            this.options.afterDataTableRender(this.dataTable);
        }

        this.afterDataTableRenderChild();
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('viewSettings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }

            this.options.userSettings.set('viewSettings', settings);
            this.options.userSettings.save();
        }
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {
    },
    editRow: function (model) {
    },
    statusChanged: function (statuses) {
    },
    childRowToggle: function (sender, rowOverride) {
        let $target = rowOverride ? $(rowOverride.selector.rows).find('.timecard-dataentry-toggle-row') : $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown() && rowOverride == null) {
            // This row is already open - close it
            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                return childDt.options.parentId !== id;
            }, this));
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRow(row, id);
        }
    },
    renderChildRow: function (row, parentId) {
        //row.child.hide();
        let childClass = 'subgrid-' + parentId.toString(),
            $childTable = $('<div data-id="' + parentId + '" />', {
                class: childClass + ' p-2'
            });
        row.child($childTable).show();

        let childData = this.getRowChildData(row);
        if (childData != null) {
            if (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD_DATAENTRY ||
                this.options.view === PJQ.constants.timecards.view.BY_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD ||
                this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD) {
                let childTable = this.getRowChildTable({
                    el: $childTable,
                    data: childData,
                    parentId: parentId,
                    onApprove: this.options.onApprove,
                    isApproved: row.data().get('approvedOn') ? true : false,
                    timecardsView: this.options.timecardsView
                });
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== parentId;
                }, this));
                this.options.childDataTables.push(childTable);
            } else {
                let settings = this.getChildTableSettings(),
                    dateNow = new Date(),
                    parameters = {
                        searchFor: this.options.timecardsView.$('.input-search').val(),
                        startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                        page: 1,
                        pageSize: 2147483646,
                        orderBy: settings.orderBy,
                        orderDirection: settings.orderAscending ? 'asc' : 'desc',
                        timeZoneOffset: dateNow.getTimezoneOffset(),
                        projectId: childData.options.projectId,
                        idFilter: childData.options.idFilter
                    };

                let loader = new PJQ.Loader(this.$el.parent());
                childData.fetch({
                    type: 'GET',
                    data: parameters,
                    success: _.bind(function () {
                        loader.remove();
                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentId: parentId,
                            timecardsView: this.options.timecardsView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== parentId;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        //tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    },
    fetchTimeCards: async function (data) {
        if (data == null || typeof this.options.onApprove !== 'function') {
            return;
        }

        let timeCards;
        if (data.timeCards != null) {
            timeCards = data.timeCards;
        } else if (data.idFilter != null || data.projectId != null) {
            timeCards = new PJQ.collections.timecards.TimeCards(null, {
                projectId: data.projectId,
                idFilter: data.idFilter
            });

            let dateNow = new Date(),
                parameters = {
                    startDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                    endDate: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                    page: 1,
                    pageSize: 2147483646,
                    timeZoneOffset: dateNow.getTimezoneOffset(),
                    projectId: timeCards.options.projectId,
                    idFilter: timeCards.options.idFilter
                };

            await timeCards.fetch({
                type: 'GET',
                data: parameters
            });
        }

        return timeCards;
    }
});

PJQ.views.timecards.ProjectDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.project-toggle-row': 'childRowToggle',
        'click .approve-project-time-cards': 'approveTimeCardsClicked',
        'click .unapprove-project-time-cards': 'approveTimeCardsClicked',
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Cards',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCards(null, row);
                }, this),
                isShown: _.bind(function (row) {
                    return this.options.permissions.hasPermission('timeCards.canApprove');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['projectId', 'projectName', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'bidsDue', 'startDate', 'endDate', 'regularHours', 'overtimeHours', 'doubletimeHours'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT ||
                this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
                columns.push({
                    "columnData": "childData",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle project-toggle-row" data-type="projectId" data-id="' + row.get('projectId') + '"></i>';
                    }
                });
            }
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'projectId':
                    columns.push({
                        "columnData": "projectId",
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "columnData": "projectName",
                        "data": "attributes.projectName",
                        "title": "Project"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country"
                    });
                    break;
                case 'bidsDue':
                    columns.push({
                        "columnData": "bidsDue",
                        "data": "attributes.bidsDue",
                        "title": 'Bids Due',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('bidsDue')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'startDate':
                    columns.push({
                        "columnData": "startDate",
                        "data": "attributes.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('projectId') > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'endDate':
                    columns.push({
                        "columnData": "endDate",
                        "data": "attributes.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('projectId') > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'regularHours',
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }, this)
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'overtimeHours',
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }, this)
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'doubletimeHours',
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="show-on-row-hover">';

                    if (this.options.permissions.hasPermission('timeCards.canApprove')) {
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-project-time-cards ml-1" title="Un-Approve Time Cards"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-project-time-cards ml-1" title="Approve Time Cards"><i class="fal fa-calendar-check"></i></button>';
                    }

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "50px",
                "className": "text-center"
            });
        }

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return PJQ.constants.timecards.view.BY_PROJECT_CONTACT;
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT)
            return PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD;
    },
    getChildTableSettings: function () {
        return this.options.timecardsView.userSettings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {

        let fixedColumnsLeft = 1, fixedColumnsRight = 0;
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
            fixedColumnsLeft = 1;
            fixedColumnsRight = 1;
        }

        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.timecardsView.userSettings;
        childOpts.colReorder = {
            fixedColumnsLeft: fixedColumnsLeft,
            fixedColumnsRight: fixedColumnsRight,
            realtime: false
        };
        childOpts.timecardsView = this.options.timecardsView;
        childOpts.onApprove = this.options.onApprove;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.timeCardSettings = this.options.timeCardSettings;

        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return new PJQ.views.timecards.ContactDataTable(childOpts);
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT)
            return new PJQ.views.timecards.TimeCardDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: this.getChildTableType(),
            projectId: row.data().get('projectId'),
        };

        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT)
            return new PJQ.collections.timecards.TimeCardContacts(null, viewOptions);
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT) {
            viewOptions.idFilter = this.options.parentId;
            return new PJQ.collections.timecards.TimeCards(null, viewOptions);
        }
    },
    approveTimeCardsClicked: async function (e) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            project = row.data();
        if (project.timeCards == null) {
            let loader = new PJQ.Loader($target);
            project.timeCards = await this.fetchTimeCards({
                projectId: project.get('projectId'),
                idFilter: this.options.parentId
            })
            loader.remove();
        }

        if (_.size(project.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This project has no time cards to approve for the selected dates'
            });
            return;
        }

        let approveNote;
        if (project.timeCards.options.idFilter != null) {
            approveNote = "Are you sure you want to approve this contact's time cards for the selected project?";
        } else {
            approveNote = "Are you sure you want to approve this project's time cards for all contacts?";
        }
        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: approveNote,
            onYes: _.bind(function () {
                this.options.onApprove(project.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }, this)
        });
    },
    approveTimeCards: async function (e, row) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = null;
        if (e != null) {
            $target = $(e.currentTarget);
            row = this.getRow($target.closest('tr'));
        }

        let project = row.data();
        if (project.timeCards == null) {
            let loader = null;
            if ($target != null) {
                loader = new PJQ.Loader($target);
            }

            project.timeCards = await this.fetchTimeCards({
                projectId: project.get('projectId'),
                idFilter: this.options.parentId
            })

            if (loader != null) {
                loader.remove();
            }
        }

        if (_.size(project.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This project has no time cards to approve for the selected dates'
            });
            return;
        }

        let approveNote;
        if (project.timeCards.options.idFilter != null) {
            approveNote = "Are you sure you want to approve this contact's time cards for the selected project?";
        } else {
            approveNote = "Are you sure you want to approve this project's time cards for all contacts?";
        }
        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: approveNote,
            onYes: _.bind(function () {
                this.options.onApprove(project.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }, this)
        });
    }
});

PJQ.views.timecards.ContactDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .approve-contact-time-cards': 'approveTimeCardsClicked',
        'click .unapprove-contact-time-cards': 'approveTimeCardsClicked',
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Cards',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCards(null, row);
                }, this),
                isShown: _.bind(function (row) {
                    return this.options.permissions.hasPermission('timeCards.canApprove');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['companyName', 'contactName', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'fax', 'cell', 'email', 'userTypeId', 'regularHours', 'overtimeHours', 'doubletimeHours'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT ||
                this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
                columns.push({
                    "columnData": "childData",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle contact-toggle-row" data-type="id" data-id="' + row.get('id') + '"></i>';
                    }
                });
            }
        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company"
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contactName",
                        "title": "Contact"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country"
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'userTypeId':
                    columns.push({
                        "columnData": 'userTypeId',
                        "title": 'Type',
                        "data": 'attributes.userTypeId',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(null), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'regularHours',
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }, this)
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'overtimeHours',
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }, this)
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '50px',
                        "orderable": true,
                        "className": 'doubletimeHours',
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="show-on-row-hover">';

                    if (this.options.permissions.hasPermission('timeCards.canApprove')) {
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-contact-time-cards ml-1" title="Un-Approve Time Cards"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-contact-time-cards ml-1" title="Approve Time Cards"><i class="fal fa-calendar-check"></i></button>';
                    }

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "50px",
                "className": "text-center"
            });
        }

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return PJQ.constants.timecards.view.BY_CONTACT_PROJECT;
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT)
            return PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD;
    },
    getChildTableSettings: function () {
        return this.options.timecardsView.userSettings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {

        let fixedColumnsLeft = 1, fixedColumnsRight = 0;
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
            fixedColumnsLeft = 1;
            fixedColumnsRight = 1;
        }

        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.timecardsView.userSettings;
        childOpts.colReorder = {
            fixedColumnsLeft: fixedColumnsLeft,
            fixedColumnsRight: fixedColumnsRight,
            realtime: false
        };
        childOpts.timecardsView = this.options.timecardsView;
        childOpts.onApprove = this.options.onApprove;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.timeCardSettings = this.options.timeCardSettings;

        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return new PJQ.views.timecards.ProjectDataTable(childOpts);
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT)
            return new PJQ.views.timecards.TimeCardDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: this.getChildTableType(),
            idFilter: row.data().get('id'),
        };

        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT)
            return new PJQ.collections.timecards.TimeCardProjects(null, viewOptions);
        if (this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT) {
            viewOptions.projectId = this.options.parentId;
            return new PJQ.collections.timecards.TimeCards(null, viewOptions);
        }
    },
    approveTimeCardsClicked: async function (e, row) {
        return await this.approveTimeCards(e);
    },
    approveTimeCards: async function (e, row) {
        if (typeof this.options.onApprove !== 'function') {
            return;
        }

        let $target = null;
        if (e != null) {
            $target = $(e.currentTarget);
            row = this.getRow($target.closest('tr'));
        }

        let contact = row.data();
        if (contact.timeCards == null) {
            let loader = null;
            if ($target != null) {
                loader = new PJQ.Loader($target);
            }

            contact.timeCards = await this.fetchTimeCards({
                projectId: this.options.parentId,
                idFilter: contact.get('id')
            })

            if (loader != null) {
                loader.remove();
            }
        }

        if (_.size(contact.timeCards.models.filter((c) => {
            return c.get('approvedOn') == null;
        })) === 0) {
            PJQ.notifications.notify.warningNotify({
                message: 'This contact has no time cards to approve for the selected dates'
            });
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Approve Time Cards",
            body: "Are you sure you want to approve this contact's time cards for " + (contact.timeCards.options.projectId > 0 ? 'the selected project' : 'all projects') + "?",
            onYes: () => {
                this.options.onApprove(contact.timeCards.models, true, () => {
                    row.invalidate().draw();
                });
            }
        });
    }
});

PJQ.views.timecards.TimeCardDataTable = PJQ.views.timecards.BaseDataTable.extend({
    events: {
        'click i.timecard-toggle-row': 'childRowToggle',
        'click .view-time-card': 'viewTimeCardClicked',
        'click .delete-time-card': 'deleteTimeCardClicked',
        'click .approve-time-card': 'approveTimeCardClicked',
        'click .unapprove-time-card': 'approveTimeCardClicked',
        'click .select-all-timecards': 'selectAll',
        'click .select-timecard': 'selectTimeCard'
    },
    onRowDoubleClick: function (row) {
        this.viewTimeCard(row);
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Approve Time Card',
                iconClass: 'fal fa-calendar-check',
                onClick: _.bind(function (row) {
                    this.approveTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin'))) && !row.data().get('approvedOn'));
                }, this)
            },
            {
                name: 'Un-Approve Time Card',
                iconClass: 'fal fa-calendar-times',
                onClick: _.bind(function (row) {
                    this.approveTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin'))) && _.size(row.data().get('approvedOn')) > 0);
                }, this)
            },
            {
                name: 'View Time Card',
                iconClass: 'fal fa-arrow-alt-from-left',
                onClick: _.bind(function (row) {
                    this.viewTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return true;
                }, this)
            },
            {
                name: 'Delete Time Card',
                iconClass: 'fal fa-trash',
                onClick: _.bind(function (row) {
                    this.deleteTimeCard(row);
                }, this),
                isShown: _.bind(function (row) {
                    return (!row.data().get('approvedOn') && (this.options.permissions.hasPermission('timeCards.isAdmin')));
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = [];

        if (this.options.settings.view === PJQ.constants.timecards.view.BY_TIMECARD || this.options.settings.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD)
            includeColumns = ['projectId', 'projectName', 'projectAddress1', 'projectAddress2', 'projectCity', 'projectState', 'projectZip', 'projectCountry', 'projectBidsDue', 'projectStartDate', 'projectEndDate', 'companyName', 'contactName', 'contactAddress1', 'contactAddress2', 'contactCity', 'contactState', 'contactZip', 'contactCountry', 'contactPhone', 'contactCell', 'contactFax', 'contactEmail', 'contactUserTypeId'];

        includeColumns.push(...['date', 'notes', 'regularHours', 'overtimeHours', 'doubletimeHours', 'approvedOn']);

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.timecardsView && (this.options.timecardsView.selectionMode !== PJQ.constants.timecards.selectionMode.NONE)) {
                columns.push({
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-timecards" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderTimeCardSelect, this)
                });
            }

            columns.push({
                "columnData": 'icons',
                "title": "<i class='fas fa-check text-green fs-18 mr-1' title='Approval Status'></i>",
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let icons = [];

                    if (row.get('approvedOn')) {
                        icons.push("<i class='fas fa-check text-green fs-18 mr-1' title='Approved'></i>");
                    }

                    return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                }, this)
            });

        }
        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'projectId':
                    columns.push({
                        "columnData": "projectId",
                        "data": "attributes.project.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "columnData": "projectName",
                        "data": "attributes.project.projectName",
                        "title": "Project"
                    });
                    break;
                case 'projectAddress1':
                    columns.push({
                        "columnData": "projectAddress1",
                        "data": "attributes.project.address1",
                        "title": (includeAllColumns ? 'Project ' : '') + "Address 1"
                    });
                    break;
                case 'projectAddress2':
                    columns.push({
                        "columnData": "projectAddress2",
                        "data": "attributes.project.address2",
                        "title": (includeAllColumns ? 'Project ' : '') + "Address 2"
                    });
                    break;
                case 'projectCity':
                    columns.push({
                        "columnData": "projectCity",
                        "data": "attributes.project.city",
                        "title": (includeAllColumns ? 'Project ' : '') + "City"
                    });
                    break;
                case 'projectState':
                    columns.push({
                        "columnData": "projectState",
                        "data": "attributes.project.state",
                        "title": (includeAllColumns ? 'Project ' : '') + "State"
                    });
                    break;
                case 'projectZip':
                    columns.push({
                        "columnData": "projectZip",
                        "data": "attributes.project.zip",
                        "title": (includeAllColumns ? 'Project ' : '') + "Zip"
                    });
                    break;
                case 'projectCountry':
                    columns.push({
                        "columnData": "projectCountry",
                        "data": "attributes.project.country",
                        "title": (includeAllColumns ? 'Project ' : '') + "Country"
                    });
                    break;
                case 'projectBidsDue':
                    columns.push({
                        "columnData": "projectBidsDue",
                        "data": "attributes.project.bidsDue",
                        "title": 'Bids Due',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'projectStartDate':
                    columns.push({
                        "columnData": "projectStartDate",
                        "data": "attributes.project.startDate",
                        "title": 'Start Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('project').projectId > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').startDate), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'projectEndDate':
                    columns.push({
                        "columnData": "projectEndDate",
                        "data": "attributes.project.endDate",
                        "title": 'End Date',
                        "width": '90px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return (row.get('project').projectId > 0) ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('project').endDate), PJQ.helpers.dateHelpers.dateFormats.DATE) : 'N/A';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.contact.companyName",
                        "title": "Company"
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contact.contactName",
                        "title": "Contact"
                    });
                    break;
                case 'contactAddress1':
                    columns.push({
                        "columnData": "contactAddress1",
                        "data": "attributes.contact.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'contactAddress2':
                    columns.push({
                        "columnData": "contactAddress2",
                        "data": "attributes.contact.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'contactCity':
                    columns.push({
                        "columnData": "contactCity",
                        "data": "attributes.contact.city",
                        "title": "City"
                    });
                    break;
                case 'contactState':
                    columns.push({
                        "columnData": "contactState",
                        "data": "attributes.contact.state",
                        "title": "State"
                    });
                    break;
                case 'contactZip':
                    columns.push({
                        "columnData": "contactZip",
                        "data": "attributes.contact.zip",
                        "title": "Zip"
                    });
                    break;
                case 'contactCountry':
                    columns.push({
                        "columnData": "contactCountry",
                        "data": "attributes.contact.country",
                        "title": "Country"
                    });
                    break;
                case 'contactPhone':
                    columns.push({
                        "columnData": "contactPhone",
                        "data": "attributes.contact.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').phone ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').phone) : 'N/A');

                            if (row.get('contact').phone !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactCell':
                    columns.push({
                        "columnData": "contactCell",
                        "data": "attributes.contact.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').cell ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').cell) : 'N/A');

                            if (row.get('contact').cell !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactFax':
                    columns.push({
                        "columnData": "contactFax",
                        "data": "attributes.contact.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('contact').fax ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('contact').fax) : 'N/A');

                            if (row.get('contact').fax !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'contactEmail':
                    columns.push({
                        "columnData": "contactEmail",
                        "data": "attributes.contact.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('contact').email ? ('<a title="' + row.get('contact').email + '" style="color: inherit;" href="mailto:' + row.get('contact').email + '">' + row.get('contact').email + '</a>') : '');

                            if (row.get('contact').email !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('contact').email + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'contactUserTypeId':
                    columns.push({
                        "columnData": 'contactUserTypeId',
                        "title": 'Type',
                        "data": 'userTypeId',
                        "orderable": false,
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(null), _.bind(function (userType) {
                                return row.get('contact').userTypeId === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'date':
                    columns.push({
                        "columnData": "date",
                        "data": "attributes.date",
                        "title": "Date",
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('date')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'notes':
                    columns.push({
                        "columnData": "notes",
                        "data": "attributes.notes",
                        "orderable": false,
                        "title": "Notes",
                        "width": "200px"
                    });
                    break;
                case 'regularHours':
                    columns.push({
                        "columnData": "regularHours",
                        "data": "attributes.regularHours",
                        "title": 'Reg. Hours',
                        "width": '50px',
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('regularHours'));
                        }, this)
                    });
                    break;
                case 'overtimeHours':
                    columns.push({
                        "columnData": "overtimeHours",
                        "data": "attributes.overtimeHours",
                        "title": 'OT Hours',
                        "width": '50px',
                        "orderable": true,
                        "visible": this.options.timeCardSettings.get('enableOvertime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('overtimeHours'));
                        }, this)
                    });
                    break;
                case 'doubletimeHours':
                    columns.push({
                        "columnData": "doubletimeHours",
                        "data": "attributes.doubletimeHours",
                        "title": 'DT Hours',
                        "width": '50px',
                        "orderable": true,
                        "visible": this.options.timeCardSettings.get('enableDoubletime'),
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.timecards.getFormattedTime(row.get('doubletimeHours'));
                        }, this)
                    });
                    break;
                case 'approvedOn':
                    columns.push({
                        "columnData": "approvedOn",
                        "data": "attributes.approvedOn",
                        "title": "Approved On",
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            return row.get('approvedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('approvedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false) : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    html += '<div class="' + (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD || this.options.view === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD ? 'show-on-row-hover' : '') + '">';

                    if (PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canApprove') || this.options.permissions.hasPermission('timeCards.isAdmin')))
                        html += row.get('approvedOn') ? '<button type="button" class="btn btn-secondary unapprove-time-card ml-1" title="Un-Approve Time Card"><i class="fal fa-calendar-times"></i></button>' : '<button type="button" class="btn btn-secondary approve-time-card ml-1" title="Approve Time Card"><i class="fal fa-calendar-check"></i></button>';

                    html += '<button type="button" class="btn btn-info view-time-card ml-1" title="View Time Card"><i class="fal fa-arrow-alt-from-left"></i></button>';

                    if (!row.get('approvedOn') && (this.options.permissions.hasPermission('timeCards.isAdmin')))
                        html += '<button type="button" class="btn btn-danger delete-time-card ml-1" title="Delete Time Card"><i class="fal fa-trash"></i></button>';

                    html += '</div>';
                    return html;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "120px",
                "className": "text-center"
            });
        }

        return columns;
    },
    selectAll: function (e) {
        let isChecked = $(e.currentTarget).prop('checked');

        if (this.options.view === PJQ.constants.timecards.view.BY_TIMECARD) {
            if (isChecked) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'timecards'
                        },
                        {
                            endpoint: 'ids'
                        }
                    ], [
                        {
                            parameter: 'searchFor',
                            value: this.options.timecardsView.$('.input-search').val()
                        },
                        {
                            parameter: 'startDate',
                            value: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
                        },
                        {
                            parameter: 'endDate',
                            value: PJQ.helpers.dateHelpers.getDateString(this.options.timecardsView.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
                        }
                    ]),
                    isAPIv2: true
                }).get().done(_.bind(function (response) {
                    this.options.timecardsView.addSelectedTimeCards(response.timeCardIds);
                }, this));
            } else {
                this.options.timecardsView.selectedTimeCards = [];
            }
        } else {
            let timeCardIds = [];
            this.dataTable.rows().data().each(_.bind(function (data) {
                timeCardIds.push(data.get('timeCardId'));
            }));

            if (isChecked)
                this.options.timecardsView.addSelectedTimeCards(timeCardIds);
            else
                this.options.timecardsView.removeSelectedTimeCards(timeCardIds);
        }

        this.dataTable.rows().invalidate().draw(false);
    },
    selectTimeCard: function (e) {
        let isChecked = $(e.currentTarget).prop('checked'), row = this.getRow($(e.currentTarget).closest('tr'));

        if (isChecked)
            this.options.timecardsView.addSelectedTimeCards([row.data().get('timeCardId')]);
        else
            this.options.timecardsView.removeSelectedTimeCards([row.data().get('timeCardId')]);
    },
    renderTimeCardSelect: function (data, type, row) {
        let isSelected = (this.options.timecardsView.selectedTimeCards.indexOf(row.get('timeCardId')) !== -1);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-timecard" />' +
            '<div class="state p-primary"><label class="wd-0">&nbsp;</label></div>' +
            '</div></div>';

        return (html);
    },
    captureSignature: function (callback) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_TIMECARDS_SIGNATURE)) {
            new PJQ.views.signatures.SignatureSubmitModal({
                headerSubText: "Sign off on your time card changes",
                onSubmit: _.bind(function (signature, cb) {
                    cb();
                    callback(signature ? signature : "");
                }, this)
            });
        } else {
            callback(null);
        }
    },
    viewTimeCard: function (row) {
        let timeCard = new PJQ.models.timecards.TimeCard({timeCardId: row.data().get('timeCardId')}, {
            context: row.data().get('context')
        });

        timeCard.fetch({
            success: _.bind(function () {
                this.originalTimeCard = {
                    regularHours: timeCard.get('regularHours'),
                    overtimeHours: timeCard.get('overtimeHours'),
                    doubletimeHours: timeCard.get('doubletimeHours')
                };

                let editModal = new PJQ.views.timecards.TimeCardDetailsModal({
                    project: this.options.project,
                    settings: this.options.timeCardSettings,
                    permissions: PJQ.app.session.project ? PJQ.app.session.project.permissions : PJQ.app.session.systemPermissions,
                    model: timeCard,
                    onSave: _.bind(function () {
                        let fnSave = _.bind(function (signature) {
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'timecards',
                                    },
                                    {
                                        endpoint: 'batch'
                                    }
                                ]),
                                data: {
                                    rows: [timeCard],
                                    signature: signature
                                },
                                isAPIv2: true
                            }).post().success(_.bind(function (data) {
                                row.data().set('notes', timeCard.get('notes'));
                                row.data().set('regularHours', timeCard.get('regularHours'));
                                row.data().set('overtimeHours', timeCard.get('overtimeHours'));
                                row.data().set('doubletimeHours', timeCard.get('doubletimeHours'));
                                row.data().set('approvedOn', timeCard.get('approvedOn'));

                                row.invalidate().draw(false);
                                let offsets = {
                                    regularHours: timeCard.get('regularHours') - this.originalTimeCard.regularHours,
                                    overtimeHours: timeCard.get('overtimeHours') - this.originalTimeCard.overtimeHours,
                                    doubletimeHours: timeCard.get('doubletimeHours') - this.originalTimeCard.doubletimeHours
                                };
                                this.updateParentRows(offsets, row);

                                PJQ.notifications.notify.successNotify({
                                    message: 'Time Card saved successfully'
                                });

                                if(typeof this.options.onChange === 'function'){
                                    this.options.onChange(timeCard);
                                }
                            }, this));
                        }, this);

                        if (timeCard.get('id') === -PJQ.app.session.user.id) {
                            this.captureSignature(_.bind(function (signature) {
                                fnSave(signature);
                                editModal.removeModal();
                            }, this));
                        } else {
                            fnSave();
                            editModal.removeModal();
                        }
                        return false;
                    }, this),
                    onDelete: _.bind(function () {
                        this.deleteTimeCard(row, true);

                        if(typeof this.options.onChange === 'function'){
                            this.options.onChange(timeCard);
                        }
                    }, this)
                });
            }, this),
        });
    },
    viewTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.viewTimeCard(row);
    },
    updateParentRows: function (offsets, row) {
        if (this.options.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD ||
            this.options.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD) {
            let parentTR = this.options.parentDataTable ? $(row.node()).parent().closest('tr').prev() : null,
                parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

            if (parentRow !== null) {
                parentRow.data().set('regularHours', parentRow.data().get('regularHours') + offsets.regularHours);
                parentRow.data().set('overtimeHours', parentRow.data().get('overtimeHours') + offsets.overtimeHours);
                parentRow.data().set('doubletimeHours', parentRow.data().get('doubletimeHours') + offsets.doubletimeHours);
                parentRow.invalidate().draw(false);

                let grandParentTR = $(parentRow.node()).parent().closest('tr').prev(),
                    grandParentRow = this.options.parentDataTable.options.parentDataTable.getRow(grandParentTR);
                grandParentRow.data().set('regularHours', grandParentRow.data().get('regularHours') + offsets.regularHours);
                grandParentRow.data().set('overtimeHours', grandParentRow.data().get('overtimeHours') + offsets.overtimeHours);
                grandParentRow.data().set('doubletimeHours', grandParentRow.data().get('doubletimeHours') + offsets.doubletimeHours);
                grandParentTR.find('.regularHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('regularHours')));
                grandParentTR.find('.overtimeHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('overtimeHours')));
                grandParentTR.find('.doubletimeHours').text(PJQ.helpers.timecards.getFormattedTime(grandParentRow.data().get('doubletimeHours')));
            }
        }
    },
    deleteTimeCard: function (row, force) {
        let fn = _.bind(function () {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'timecards',
                        value: row.data().get('timeCardId')
                    }
                ]),
                isAPIv2: true
            }).delete().done(_.bind(function (response) {
                let timeCard = row.data(),
                    offsets = {
                    regularHours: -timeCard.get('regularHours'),
                    overtimeHours: -timeCard.get('overtimeHours'),
                    doubletimeHours: -timeCard.get('doubletimeHours'),
                };
                this.updateParentRows(offsets, row);
                row.remove().draw();

                if(typeof this.options.onChange === 'function'){
                    this.options.onChange(timeCard);
                }
            }, this));
        }, this);

        if (force)
            fn();
        else {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Time Card",
                body: "Do you want to delete this Time Card?",
                onDelete: _.bind(function () {
                    fn();
                }, this)
            });
        }
    },
    deleteTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteTimeCard(row);
    },
    approveTimeCardClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.approveTimeCard(row);
    },
    approveTimeCard: function (row) {
        let timeCard = row.data(),
            approve = timeCard.get('approvedOn') == null,
            action = (approve ? 'Approve' : 'Un-Approve');
        if (typeof this.options.onApprove === 'function') {
            new PJQ.views.modals.YesNo({
                header: action + " Time Card",
                body: "Are you sure you want to " + action.toLowerCase() + " this time card?",
                onYes: _.bind(function () {
                    this.options.onApprove(row.data(), approve, () => {
                        row.invalidate().draw();
                    });
                }, this)
            });
        }
    }
});

// Data Entry Datatables
PJQ.views.timecards.TimeCardDataEntryTable = PJQ.views.timecards.BaseDataTable.extend({
    defaults: {
        isHideSearch: true,
        order: [],
        dom: 't',
        pageLength: 5,
        language: {
            zeroRecords: "No Time Cards to edit"
        },
        drawCallback: _.bind(function (settings) {
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-regular-hours'), 2);
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-overtime-hours'), 2);
            PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-doubletime-hours'), 2);
        }, this),
    },
    events: {
        'click i.timecard-dataentry-toggle-row': 'childRowToggle',
        'change .input-notes': 'valueChanged',
        'change .input-regular-hours': 'valueChanged',
        'change .input-overtime-hours': 'valueChanged',
        'change .input-doubletime-hours': 'valueChanged',
        'click .delete-time-card': 'deleteTimeCard'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];

        if (this.options.groupByColumn === PJQ.constants.timecards.timeCardGroupBy.DATE) {
            columns.push({
                "data": "attributes.contact.companyName",
                "title": "Company",
                "orderable": false
            });

            columns.push({
                "data": "attributes.contact.contactName",
                "title": "Contact",
                "orderable": false
            });
        }

        if (this.options.groupByColumn === PJQ.constants.timecards.timeCardGroupBy.CONTACT) {
            columns.push({
                    "data": "attributes.date",
                    "title": "Date",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(row.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, false);
                    }, this)
                },
            );

        }

        columns.push({
            "title": "Notes",
            "orderable": false,
            "width": '200px',
            "render": _.bind(function (data, type, row) {
                if (!row.get('approvedOn')) {
                    return '<textarea type="text" class="form-control input-notes" data-field="notes">' + row.get('notes') + '</textarea>';
                } else {
                    return row.get('notes');
                }
            }, this)
        });

        columns.push({
            "title": "Reg.",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('regularHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-regular-hours" data-field="regularHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });
        columns.push({
            "title": "OT",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('overtimeHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-overtime-hours" data-field="overtimeHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });
        columns.push({
            "title": "DT",
            "width": '50px',
            "orderable": false,
            "render": _.bind(function (data, type, row) {
                let value = PJQ.helpers.formatHelpers.formatCurrency(row.get('doubletimeHours'), 2, false);
                if (!row.get('approvedOn')) {
                    return '<input type="text" class="form-control input-doubletime-hours" data-field="doubletimeHours" value="' + value + '">';
                } else {
                    return value;
                }
            }, this)
        });

        columns.push({
            "title": '',
            "render": _.bind(function (data, type, row) {
                let html = '';
                html += '<div class="show-on-row-hover">';

                if (!row.get('approvedOn') &&
                    ((PJQ.app.session.contact == null && (this.options.permissions.hasPermission('timeCards.canAdd') || this.options.permissions.hasPermission('timeCards.isAdmin'))) ||
                        (PJQ.app.session.contact && this.options.permissions.hasPermission('timeCards.canAdd')))
                ) {
                    if (!PJQ.app.session.contact || !row.get('timeCardId'))
                        html += '<button type="button" class="btn btn-danger delete-time-card ml-1" title="Delete Time Card"><i class="fal fa-trash"></i></button>';
                }
                html += '</div>';
                return html;
            }, this),
            "orderable": false,
            "searchable": false,
            "width": "80px",
            "className": "text-center"
        });

        if (!includeAllColumns) {

        }

        return columns;
    },
    valueChanged: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')[0]),
            fieldName = $(e.currentTarget).data('field'),
            value = ($(e.currentTarget).hasClass('input-notes')) ? $(e.currentTarget).val() : parseInt(parseFloat($(e.currentTarget).val()) * 100);

        row.data().set(fieldName, value);

        if (fieldName !== 'notes')
            $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(row.data().get(fieldName), 2, false));
    },
    deleteTimeCard: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')[0]);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Time Card",
            body: "Do you want to delete this Time Card?" + (this.options.timecardsModal.options.timeCard == null && !row.data().isNew() ? '<br /><br /><b>Note:</b> You will need to click Save after finishing all editing in order to save your changes.' : ''),
            onDelete: _.bind(function () {

                if (this.options.timecardsModal.options.timeCard === null) {
                    if (row.data().isNew()) {
                        this.options.timecardsModal.model.remove([row.data()]);
                        row.remove().draw();
                    } else {
                        row.data().set('deletedOn', new Date());
                        row.remove().draw();
                    }
                } else {
                    row.data().set('deletedOn', new Date());
                    this.options.timecardsModal.saveTimeCards(null, true);
                }
            }, this)
        });
    }
});